import type { SurveysStore } from './interfaces'

import { emptySurveysFilters } from '@helpers/surveys-query'

export const actions = {
  setLoading (this: SurveysStore, payload: SurveysStore['loading']): void {
    this.loading = payload
  },
  setExporting (this: SurveysStore, payload: SurveysStore['exporting']): void {
    this.exporting = payload
  },
  setDisciplineId (this: SurveysStore, payload: SurveysStore['disciplineId']): void {
    if (this.disciplineId === payload) return

    this.disciplineId = payload
    this.surveys = []
    this.meta = null
  },
  setSurveys (this: SurveysStore, payload: SurveysStore['surveys']): void {
    this.surveys = payload
  },
  setMeta (this: SurveysStore, payload: SurveysStore['meta']): void {
    this.meta = payload
  },
  setFilters (this: SurveysStore, payload: SurveysStore['filters']): void {
    this.filters = payload
  },
  setFilterSearch (this: SurveysStore, payload: SurveysStore['filters']['search']): void {
    this.filters.search = payload
  },
  setFilterDates (this: SurveysStore, payload: Pick<SurveysStore['filters'], 'from' | 'to'>): void {
    this.filters.from = payload.from
    this.filters.to = payload.to
  },
  setFilterType (this: SurveysStore, payload: SurveysStore['filters']['type']): void {
    this.filters.type = payload
  },
  setFilterStatuses (this: SurveysStore, payload: SurveysStore['filters']['statuses']): void {
    this.filters.statuses = payload
  },
  setFilterSource (this: SurveysStore, payload: SurveysStore['filters']['source']): void {
    this.filters.source = payload
  },
  setFilterTutorIds (this: SurveysStore, payload: SurveysStore['filters']['tutorIds']): void {
    this.filters.tutorIds = payload
  },
  setCurrentPage (this: SurveysStore, payload: SurveysStore['currentPage']): void {
    this.currentPage = payload
  },
  setPerPage (this: SurveysStore, payload: SurveysStore['perPage']): void {
    this.perPage = payload
  },
  resetFilters (this: SurveysStore): void {
    this.filters = emptySurveysFilters()
    this.currentPage = 1
  },
  /** The list answer goes with the page it was read for: the next visit starts empty, under its loader, never
   *  showing stale rows until its own land. Filters and paging stay. */
  resetList (this: SurveysStore): void {
    this.surveys = []
    this.meta = null
  },
}
